import React from "react";
import "./about.css";

const partners = [
  {
    name: "Aaron Hardiman",
    role: "Entrepreneur",
    image: "../images/about_images/partners/Aaron_Hardiman.jpeg",
    linkedin: "https://www.linkedin.com/in/aaron-hardiman/",
  },
  {
    name: "David Green",
    role: "Green Resilience Insights",
    image: "../images/about_images/partners/David_Green.jpeg",
    linkedin: "https://www.linkedin.com/in/david-green-3115a5a/",
  },
  {
    name: "David Savarese",
    role: "Jacobs",
    image: "../images/about_images/partners/David_Savarase.jpeg",
    linkedin: "https://www.linkedin.com/in/david-savarese-aicp-8533767/",
  },
  {
    name: "Helio Mosquim",
    role: "Vale",
    image: "../images/about_images/partners/Helio(1).jpeg",
    linkedin: "https://www.linkedin.com/in/heliomosquim/",
  },
  {
    name: "Jennifer George",
    role: "Nakoudu",
    image: "../images/about_images/partners/Jennifer_George.jpeg",
    linkedin:
      "https://www.linkedin.com/in/jennifer-george-mba-gaicd-120ba210/?originalSubdomain=au",
  },
  {
    name: "Josh Wilkins",
    role: "Fireline Solutions",
    image: "../images/about_images/partners/Josh_Wilkins.jpeg",
    linkedin: "https://www.linkedin.com/in/joshwilkins1/",
  },
  {
    name: "Kathryn Myronuk",
    role: "Singularity",
    image: "../images/about_images/partners/Kathryn_Myronuk.jpeg",
    linkedin: "https://www.linkedin.com/in/kathrynmyronuk/",
  },
  {
    name: "Lindon Pronto",
    role: "European Forest Institute",
    image: "../images/about_images/partners/Lindon_Pronto.png",
    linkedin: "https://www.linkedin.com/in/lindon-n-pronto/",
  },
  {
    name: "Sal Garcia",
    role: "Garcia's Management",
    image: "../images/about_images/partners/Sal_Garcia.png",
    linkedin: "https://www.linkedin.com/in/sal-garcia-89295a9/",
  },
  {
    name: "Tammy Schwartz",
    role: "Guidewire",
    image: "../images/about_images/partners/Tammy_Schwartz.jpeg",
    linkedin: "https://www.linkedin.com/in/tammynicholsschwartz/",
  },
  {
    name: "Tim Ball",
    role: "Fireball Companies",
    image: "../images/about_images/partners/tim_ball.jpeg",
    linkedin: "https://www.linkedin.com/in/tim-ball-1832a824/",
  },
  {
    name: "Yongbo Du",
    role: "Innovo",
    image: "../images/about_images/partners/Yangbo_Du.jpeg",
    linkedin: "https://www.linkedin.com/in/yangbodu/",
  },
  // Add other partners here
];

const Partners = () => {
  return (
    <div className="partners-container">
      <div className="partners-title">
        <h1>Innovation Curation Partners</h1>
        <p>
          Thank you to our partners and collaborators for all your time, wisdom
          and support
        </p>
      </div>
      <div className="partners">
        {partners.map((partner, index) => (
          <div className="card" key={index}>
            <img src={partner.image} alt={partner.name} />
            <h5>
              {partner.name}, <br />
              {partner.role}
            </h5>
            {partner.linkedin && (
              <a
                href={partner.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="linkedin-link"
              >
                <i className="fab fa-linkedin"></i>
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partners;
